<span [style.visibility]="isLoading ? 'hidden' : 'visible'">
  <ng-content></ng-content>
</span>
@if (isLoading) {
  <progress class="mri-spinner mri-button__spinner"></progress>
}
